<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>สรุปยอดขาย</strong></v-card-title>
          </v-layout>
        <v-layout justify-center>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start align-center>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>เดือน</strong></p>
                <div>
                  <v-dialog
                    ref="dialog"
                    v-model="month_modal"
                    :return-value.sync="month"
                    width="350px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="month"
                        prepend-inner-icon="mdi-calendar"
                        outlined
                        dense
                        v-on="on"
                        color="pink lighten-2"
                      ></v-text-field>
                    </template>
                    <v-date-picker persistent v-model="month" scrollable color="pink lighten-2" width="350px" type="month" locale="th-TH">
                      <v-spacer></v-spacer>
                      <v-btn text color="pink lighten-2" @click="month_modal = false">ยกเลิก</v-btn>
                      <v-btn text color="pink" @click="selectdate()">ตกลง</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </div>
              </v-flex>
                  <div class="flex-grow-1"></div>
                  <v-flex xs4 sm6 md3 lg2 px-3>
                    <v-btn class="px-2" outlined color="indigo lighten-2" @click="exportdata('')">
                      <v-icon>mdi-publish mdi-flip-v</v-icon>&nbsp;
                      ดาวน์โหลดทั้งหมด
                    </v-btn>
                  </v-flex>
            </v-layout>
          <v-data-table
            :headers="headers"
            :items="dateorderdatas"
            :items-per-page="10"
            class="elevation-3"
            style="font-family: Kanit;"
            :loading="loading"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item.date"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="openorderlist(item.date)">{{ item.no }}</td>
                  <td @click="openorderlist(item.date)">{{ item.date_th }}</td>
                  <td>
                    <v-icon meduim @click="exportdata(item.date)">mdi-publish mdi-flip-v</v-icon>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <Productmodal />
        <Dateorderlistmodal />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Productmodal from '@/components/Productmodal'
import Dateorderlistmodal from '@/components/Dateorderlistmodal'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import { Parser } from 'json2csv'
import moment from 'moment'
moment.locale('th')
export default {
  components: {
    Productmodal,
    Dateorderlistmodal
  },
  data: () => ({
    headers: [
      { text: 'ลำดับ', align: 'center', sortable: false, value: 'no' },
      { text: 'วันที่จัดส่ง', align: 'center', sortable: false, value: 'date' },
      { text: 'ดาวน์โหลด', value: 'action', sortable: false, align: 'center' }
    ],
    dateorderdatas: [],
    csvheader: ['รหัสร้านค้า', 'ชื่อ-สกุล', 'เลขที่เอกสาร', 'สถานะ', 'เจ้าหน้าที่ผู้ดูแล', 'ยอดรวม'],
    month_modal: false,
    month: '',
    date_now: '',
    loading: false
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin' || this.$cookies.get('status') === 'admin') {
        this.date_now = (new Date()).toISOString().split('T')[0]
        this.month = `${(new Date()).toISOString().split('-')[0]}-${(new Date()).toISOString().split('-')[1]}`
        this.getdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async getdata () {
      try {
        this.loading = true
        let { data } = await axios.get(`${process.env.VUE_APP_API}/order/get/delivery`, {
          headers: {
            Authorization: this.$cookies.get('token'),
            month: this.month
          }
        })
        this.dateorderdatas = data.map((pd, index) => {
          return {
            ...pd,
            no: index + 1,
            date_th: moment(pd.date).format('LL')
          }
        })
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    exportdata (date) {
      if (date !== '') {
        let orderdatedata = this.dateorderdatas.find(order => order.date === date)
        if (orderdatedata) {
          let newdate = `${orderdatedata.date.split('-')[2]}/${orderdatedata.date.split('-')[1]}/${orderdatedata.date.split('-')[0]}`
          let header = this.csvheader
          let result = []
          orderdatedata.orderitems.forEach(order => {
            let resultdata = {
              'วันที่จัดส่ง': newdate,
              'เลขที่เอกสาร': order.order_no,
              'รหัสร้านค้า': order.username,
              'ชื่อ-สกุล': order.name,
              'สถานะ': order.order_status_th,
              'เจ้าหน้าที่ผู้ดูแล': order.adminref,
              'ยอดรวม': order.productitems.reduce((sum, product) => { return sum + Number(product.price) }, 0)
            }
            result.push(resultdata)
          })
          const json2csvParser = new Parser({ quote: '' })
          const csv = json2csvParser.parse(result, { header })
          this.download(csv, newdate)
        }
      } else {
        let header = this.csvheader
        let result = []
        this.dateorderdatas.forEach(orderdatedata => {
          let newdate = `${orderdatedata.date.split('-')[2]}/${orderdatedata.date.split('-')[1]}/${orderdatedata.date.split('-')[0]}`
          orderdatedata.orderitems.forEach(order => {
            let resultdata = {
              'วันที่จัดส่ง': newdate,
              'เลขที่เอกสาร': order.order_no,
              'รหัสร้านค้า': order.username,
              'ชื่อ-สกุล': order.name,
              'สถานะ': order.order_status_th,
              'เจ้าหน้าที่ผู้ดูแล': order.adminref,
              'ยอดรวม': order.productitems.reduce((sum, product) => { return sum + Number(product.price) }, 0)
            }
            result.push(resultdata)
          })
        })
        const json2csvParser = new Parser({ quote: '' })
        const csv = json2csvParser.parse(result, { header })
        this.download(csv, `${this.month.split('-')[1]}/${this.month.split('-')[0]}`)
      }
    },
    openorderlist (date) {
      let orderlist = this.dateorderdatas.find(od => String(od.date) === String(date))
      this.dateorderlistmodal = true
      this.currentorderlist = JSON.stringify(orderlist)
      this.currentorderlistmode = 2
    },
    selectdate () {
      this.$refs.dialog.save(this.month)
      this.date_now = new Date(this.month).toISOString().split('T')[0]
      this.getdata()
    },
    download (csv, filename) {
      var downloadLink = document.createElement('a')
      var blob = new Blob(['\ufeff', csv])
      var url = URL.createObjectURL(blob)
      downloadLink.href = url
      downloadLink.download = `${filename}.csv` // Name the file here
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    },
    computedDateFormattedMomentjs () {
      return this.month ? moment(this.month).format('ll') : ''
    }
  },
  computed: {
    productmodal: sync('productmodal'),
    currentproductdata: sync('currentproductdata'),
    currentgrouppriceid: sync('currentgrouppriceid'),
    dateorderlistmodal: sync('dateorderlistmodal'),
    currentorderlist: sync('currentorderlist'),
    currentorderlistmode: sync('currentorderlistmode')
  }
}
</script>

<style>
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}
.addbuttonstyle {
  font-family: 'Kanit';
  font-weight: bold;
}
.v-date-picker {
  font-family: 'Kanit';
}
.v-date-picker-title__date > div {
  font-family: kanit;
}
.v-date-picker-header__value button {
    font-family: 'Kanit';
}
.v-date-picker-title__year {
    font-family: 'Kanit';
}

</style>
